module.exports = __webpack_public_path__ + "static/media/liberty.e899713f.png";